import React from 'react';

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
} as const;

interface LoadingSpinnerProps {
  color: string;
  size?: keyof typeof sizeClasses;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  color,
  size = 'lg',
  className = '',
}) => (
  <div
    className={`animate-spin rounded-full border-b-2 mx-auto ${sizeClasses[size]} ${className}`}
    style={{ borderBottomColor: color }}
    role="status"
    aria-label="Loading"
  />
);
